import Reveal, { SectionHead } from "@/components/Reveal";

const featured = {
  title: "Promo Extendida",
  sub: "Cristian Díaz · 2026",
  src: "https://player.vimeo.com/video/1232341497?h=05d6b83d50&title=0&byline=0&portrait=0",
  testId: "video-frame-promo-extendida",
};

const videos = [
  { title: "Debut vs Unión Española", sub: "Primera División · 2026", src: "https://player.vimeo.com/video/1222897652?h=2fb3c2dcdf&title=0&byline=0&portrait=0", testId: "video-frame-debut" },
  { title: "vs Audax y Pto. Montt", sub: "Copa Chile · 2026", src: "https://player.vimeo.com/video/1232095125?h=49c7f776f5&title=0&byline=0&portrait=0", testId: "video-frame-copa-chile" },
  { title: "VH", sub: "Video Highlights", src: "https://player.vimeo.com/video/1137491504?h=58714cad8c&title=0&byline=0&portrait=0", testId: "video-frame-vh" },
  { title: "Promo", sub: "Presentación oficial", src: "https://player.vimeo.com/video/1137132945?h=6ed4ee038a&title=0&byline=0&portrait=0", testId: "video-frame-promo" },
  { title: "Video Análisis", sub: "Rendimiento en cancha", src: "https://player.vimeo.com/video/1137491527?h=8c33d459c7&title=0&byline=0&portrait=0", testId: "video-frame-analisis" },
];

function VideoCard({ video, featured: isFeatured }) {
  return (
    <div className="group border border-neutral-800 bg-[#0f0f0f] overflow-hidden hover:border-[#d4af37]/60 transition-colors">
      <div className="relative aspect-video">
        <iframe
          src={video.src}
          title={video.title}
          data-testid={video.testId}
          className="absolute inset-0 w-full h-full"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          loading="lazy"
        />
      </div>
      <div className="px-5 py-4 flex items-baseline justify-between gap-3">
        <p className={`font-display font-extrabold uppercase leading-tight ${isFeatured ? "text-2xl" : "text-lg"}`}>{video.title}</p>
        <p className="font-tech text-[10px] uppercase tracking-[0.25em] text-neutral-500 shrink-0">{video.sub}</p>
      </div>
    </div>
  );
}

export default function Videos() {
  return (
    <section id="videos" data-testid="videos-section" className="relative py-28 px-6 border-t border-neutral-900">
      <div className="max-w-6xl mx-auto">
        <SectionHead eyebrow="05 — Videos" title="Míralo en cancha" testId="videos-title" />
        <Reveal className="mt-14">
          <VideoCard video={featured} featured />
        </Reveal>
        <div className="mt-4 grid sm:grid-cols-2 gap-4" data-testid="videos-grid">
          {videos.map((v, i) => (
            <Reveal key={v.testId} delay={i * 0.08}>
              <VideoCard video={v} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
